export function resolveSyncState(regime) {
    if (!regime) return null
    if (regime.syncState === "synced" || regime.syncState === "outOfSync") {
        return regime.syncState
    }
    return legacyFallback(regime)
}

function legacyFallback(regime) {
    if (!regime?.registerModified || !regime?.regimeModified) return null
    return new Date(regime.registerModified) > new Date(regime.regimeModified) ? "outOfSync" : "synced"
}
